<template>
  <q-btn-dropdown
    :menu-offset="[5, 5]"
    aria-label="Notifications"
    color="primary"
    dropdown-icon="none"
    menu-anchor="bottom end"
    dense
    flat
    rounded
    @show="loadNotifications"
  >
    <template #label>
      <NotificationIcon class="icon" />
      <q-badge v-if="notificationsCount" color="error-70" floating rounded>
        {{ notificationsCount }}
      </q-badge>
      <PTooltip> Notification </PTooltip>
    </template>

    <header
      class="flex items-center justify-between q-pa-xl"
      :style="{ width: '350px' }"
    >
      <span class="text-lg text-neutral-60"> Notifications </span>
      <PBtn
        :loading="markingAsRead"
        label="Mark all as read"
        size="md"
        dense
        flat
        fluid
        @click="markAllAsRead"
      >
      </PBtn>
    </header>

    <q-separator />

    <q-virtual-scroll
      v-if="!loading && notifications.length"
      v-slot="{ item: { _id, is_read, message, title }, index }"
      :items="notifications"
      :style="{ width: '350px', maxHeight: 'calc(50vh - 137px)' }"
      virtual-scroll-slice-size="10"
      virtual-scroll-item-size="76"
      separator
    >
      <q-item
        :key="index"
        :disable="is_read"
        class="q-px-xl q-py-sm"
        clickable
        @click="() => (selectedNotification = _id)"
      >
        <q-item-section>
          <q-item-label>{{ title }}</q-item-label>
          <q-item-label caption :lines="_id === selectedNotification ? 0 : 2">
            <span v-html="message"></span>
          </q-item-label>
        </q-item-section>
      </q-item>
    </q-virtual-scroll>
    <div v-else class="q-pa-xl text-center">
      <span>
        {{ loading ? "Loading..." : "No notifications found" }}
      </span>
    </div>
  </q-btn-dropdown>
</template>

<script setup>
import NotificationIcon from "assets/icons/notification.svg";

const { notificationsCount, notifications } = storeToRefs(
  useNotificationStore(),
);
const { getNotifications, putNotification } = useNotificationStore();

const loading = ref(false);

const loadNotifications = async () => {
  try {
    if (unref(notificationsCount) > 0 || unref(notifications).length <= 0) {
      loading.value = true;

      await getNotifications();

      loading.value = false;
    }
  } catch (error) {
    console.error(error);
  }
};

const markingAsRead = ref(false);

const markAllAsRead = async () => {
  try {
    markingAsRead.value = true;

    await putNotification();

    markingAsRead.value = false;
  } catch (error) {
    console.error(error);
  }
};

const selectedNotification = ref(null);
</script>

<style lang="scss" scoped>
.q-badge {
  font-size: 10px;
  padding: 1.5px 4px;

  &--floating {
    top: 0;
    right: 0;
  }
}
.q-btn-dropdown {
  :deep(.q-btn__content) {
    .q-btn-dropdown {
      &__arrow {
        display: none;
      }
    }
  }
}
</style>
